import React, { useEffect, useState } from 'react';
import GridInputs from '../../../components/common/inputs/GridInputs';
import axios from 'axios';
import { SubmitButton } from '../../../components/common/button/CustomButtons';
import useConfirm from '../../../components/common/useConfirm';
import AutocompleteGridmui from '../../../components/common/autocomplete/AutocompleteGridmui';
import { DivStyled } from '../../../assets/styles/components/DivStyledLableInputs';
import { Grid } from '@mui/material';
import {
  AddIconButton,
  RemoveIconButton,
} from '../../../components/common/button/CustomIconButton';
import ModalCustom from '../../../components/common/Modal';
import PartTable from './PartTable';

const Create = ({
  id,
  setIsModal,
}: {
  id?: string | null;
  setIsModal: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  const [moduleData, setModuleData] = useState<any>({});
  const [customerData, setCustomerData] = useState([]);
  const [render, setRender] = useState(false);
  const [DialogSubmit, confirmSubmit] = useConfirm(
    `${id ? 'Update Fixture' : 'Create Fixture'}`,
    `Are you sure you want to ${id ? 'update' : 'save'} this?`,
  );
  const [isPartModal, setIsPartModal] = useState(false);

  useEffect(() => {
    axios
      .get('/api/customerRoutes/')
      .then((res) => {
        setCustomerData(res.data.results);
      })
      .catch((err) => console.log(err));
  }, []);

  useEffect(() => {
    if (id) {
      axios
        .get(`/api/fixturesRoute/${id}`)
        .then((res) => setModuleData(res.data))
        .catch((err) => console.log(err));
    }
  }, [id]);

  function handleDepartment(e: React.ChangeEvent<HTMLInputElement>) {
    setModuleData((prev: any) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  }

  const handleSumbit = async () => {
    const ans = await confirmSubmit();
    if (!ans) return;
    if (id) {
      await axios
        .put(`/api/fixturesRoute/${id}`, moduleData)
        .then((res) => {
          setIsModal(false);
        })
        .catch((err) => console.log(err));
    } else {
      await axios
        .post('/api/fixturesRoute', moduleData)
        .then((res) => {
          setIsModal(false);
        })
        .catch((err) => console.log(err));
    }
  };

  return (
    <>
      <GridInputs
        id={'name'}
        name={'name'}
        html_for={'name'}
        label_name={'Fixture Name:'}
        input_type={'text'}
        focusType={'onblur'}
        value={moduleData?.name}
        onChange={handleDepartment}
      />
      <GridInputs
        id={'number'}
        name={'number'}
        html_for={'number'}
        label_name={'Fixture No.:'}
        input_type={'text'}
        focusType={'onblur'}
        value={moduleData?.number}
        onChange={handleDepartment}
      />
      <GridInputs
        id={'freq'}
        name={'freq'}
        html_for={'freq'}
        label_name={'Frequency:'}
        input_type={'text'}
        focusType={'onblur'}
        value={moduleData?.freq}
        onChange={handleDepartment}
      />
      <GridInputs
        id={'location'}
        name={'location'}
        html_for={'location'}
        label_name={'Location:'}
        input_type={'text'}
        focusType={'onblur'}
        value={moduleData?.location}
        onChange={handleDepartment}
      />
      <GridInputs
        id={'responsibility'}
        name={'responsibility'}
        html_for={'responsibility'}
        label_name={'Responsibility:'}
        input_type={'text'}
        focusType={'onblur'}
        value={moduleData?.responsibility}
        onChange={handleDepartment}
      />
      <AutocompleteGridmui
        label={'Customer:'}
        id={'customer_id'}
        option_name={'customer_name'}
        value={moduleData?.customer_id || ''}
        arrayofObj={customerData}
        onChange={(e, value) => {
          moduleData.customer_id = value;
          setRender((prev) => !prev);
        }}
      />
      <DivStyled style={{ alignItems: 'center' }}>
        <label>{'Part Number'}</label>
        <div
          style={{
            borderLeft: '2px solid #ced4da',
            paddingLeft: '1rem',
            width: '100%',
          }}
        >
          <Grid container xs={12} direction="row" alignItems={'center'}>
            <Grid item xs={10}>
              <p
                style={{
                  fontSize: '1.6rem',
                }}
              >
                {typeof moduleData?.part_id === 'object' &&
                moduleData?.part_id !== null
                  ? moduleData?.part_id?.part_number
                  : moduleData?.partNumber || ''}
              </p>
            </Grid>

            {moduleData.part_id ? (
              <Grid item xs={2}>
                <RemoveIconButton
                  tooltipTitle="remove part"
                  onClick={() => {
                    moduleData.part_id = null;
                    moduleData.partNumber = null;
                    moduleData.partName = null;
                    setRender((prev) => !prev);
                  }}
                />
              </Grid>
            ) : (
              <Grid item xs={2}>
                <AddIconButton
                  tooltipTitle="add part"
                  onClick={() => {
                    setIsPartModal(true);
                  }}
                />
              </Grid>
            )}
          </Grid>
        </div>
      </DivStyled>
      <DivStyled style={{ alignItems: 'center' }}>
        <label>{'Part Name'}</label>
        <div
          style={{
            borderLeft: '2px solid #ced4da',
            paddingLeft: '1rem',
            width: '100%',
          }}
        >
          <Grid container xs={12} direction="row" alignItems={'center'}>
            <Grid item xs={10}>
              <p
                style={{
                  fontSize: '1.6rem',
                }}
              >
                {typeof moduleData?.part_id === 'object' &&
                moduleData?.part_id !== null
                  ? moduleData?.part_id?.part_name
                  : moduleData?.partName || ''}
              </p>
            </Grid>
          </Grid>
        </div>
      </DivStyled>

      <div
        className="btn_save"
        style={{
          position: 'absolute',
          right: '140px',
          top: '-0.6px',
        }}
      >
        <SubmitButton
          label={`${id ? 'update' : 'submit'}`}
          type="button"
          onClick={handleSumbit}
        />
      </div>
      <DialogSubmit />
      <ModalCustom
        openModal={isPartModal}
        closeModal={() => {
          setIsPartModal(false);
        }}
        title="PART"
      >
        <PartTable moduleData={moduleData} />
      </ModalCustom>
    </>
  );
};

export default Create;
